/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Offers_Per_MonthInputs */

const en_offers_per_month = /** @type {(inputs: Offers_Per_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / month`)
};

const pl_offers_per_month = /** @type {(inputs: Offers_Per_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / mies.`)
};

/**
* | output |
* | --- |
* | "{price} / month" |
*
* @param {Offers_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offers_per_month = /** @type {((inputs: Offers_Per_MonthInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offers_Per_MonthInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offers_per_month(inputs)
	return en_offers_per_month(inputs)
});